export const completeNotification = () => {
    window.dispatchEvent(new CustomEvent('notification-task-completed'));
};
